/* Carrito PROFESIONAL (B2B). En la página /cart Y en el cajón lateral (drawer): reescribe el precio de
   cada línea al neto B2B, oculta el total estimado (retail) + el botón COMPRAR normal, e inyecta un panel
   FT("Tu pedido profesional") con el total B2B + botón FT("Finalizar pedido profesional") (crea un draft order a
   precios B2B y lleva al pago). Se actualiza al cambiar la cantidad. Seguro: si no es B2B, no toca nada. */
(function () {
  var B = window.FRIKY_B2B;
  if (!B || !B.id) return;
  var tags = B.tags || [];
  var isB2B = B.isB2B === true || (Array.isArray(tags) ? tags : String(tags).split(',')).some(function (t) { return String(t).trim().toLowerCase() === 'b2b'; });
  if (!isB2B) return;
  var API = window.FRIKY_B2B_API || 'https://frikyshop.fly.dev/api/b2b-public';
  var onCartPage = /(^|\/)cart(\/|$|\?)/.test(location.pathname);
  var money = function (n) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
  var esc = function (s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  var unitByPid = {}, variantToPid = {}, cartData = null, cartItems = null, lastSig = '', ticks = 0;

  function refresh(cart, cb) {
    variantToPid = {};
    cart.items.forEach(function (i) { variantToPid[String(i.variant_id)] = String(i.product_id); });
    cartItems = cart.items.map(function (i) { return { productId: i.product_id, variantId: i.variant_id, quantity: i.quantity }; });
    if (!cartItems.length) { unitByPid = {}; cartData = null; cb && cb(); return; }
    fetch(API + '/cart', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customerId: B.id, email: B.email || '', items: cartItems }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.ok || !d.activated || !d.lines) { unitByPid = {}; cartData = null; console.log('[B2B-cart] tarifa off'); cb && cb(); return; }
        cartData = d; unitByPid = {};
        d.lines.forEach(function (l) { unitByPid[String(l.productId)] = l.unitNet; });
        // OJO: la clase que oculta los botones de compra normales se pone y se quita
        // en syncOn(), según haya panel B2B o no. Aquí NO se toca: si se añadía aquí y
        // luego el panel desaparecía (re-render del tema, error de red), el cliente se
        // quedaba con un carrito SIN ningún botón de comprar.
        console.log('[B2B-cart] cargado · unidades', d.units, '· total', d.total);
        cb && cb();
      }).catch(function () { cb && cb(); });
  }

  // Precio B2B en cada línea del carrito (drawer + página).
  function paintLines() {
    var orderPids = cartItems ? cartItems.map(function (i) { return String(i.productId); }) : [];
    var pIdx = 0;
    document.querySelectorAll('.cart-item').forEach(function (li) {
      var v = li.getAttribute('data-variant-id');
      var pid = v ? variantToPid[v] : orderPids[pIdx];
      if (!v) pIdx++;
      if (!pid) return;
      var net = unitByPid[pid]; if (net == null) return;
      var priceEl = li.querySelector('.price'); if (!priceEl) return;
      var orig = priceEl.getAttribute('data-b2b-orig');
      if (orig === null) { orig = priceEl.textContent.replace(/\s+/g, ' ').trim(); priceEl.setAttribute('data-b2b-orig', orig); }
      if (priceEl.getAttribute('data-b2b') === String(net)) return;
      priceEl.setAttribute('data-b2b', String(net));
      priceEl.innerHTML = '<span class="fb2bcl">' + (orig ? '<s>' + esc(orig) + '</s>' : '') + '<b>' + money(net) + '</b><em>PRO · sin IVA</em></span>';
    });
  }

  function doCheckout() {
    var b = this; b.disabled = true; var old = b.textContent; b.textContent = FT('Creando tu pedido…');
    fetch(API + '/checkout', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customerId: B.id, email: B.email || '', items: cartItems }) })
      .then(function (r) { return r.json(); }).then(function (r) {
        // Shopify tarda 1-2s en dejar lista la factura del draft → esperamos antes de redirigir (si no: "invoice not available yet").
        if (r && r.ok && r.invoiceUrl) { b.textContent = FT('Preparando tu pago…'); setTimeout(function () { window.location.href = r.invoiceUrl; }, 2200); return; }
        b.disabled = false; b.textContent = old; alert(FT('No se pudo crear el pedido profesional') + (r && r.error ? ': ' + r.error : '.'));
      }).catch(function () { b.disabled = false; b.textContent = old; alert(FT('Error al crear el pedido.')); });
  }

  function buildPanel(compact) {
    var d = cartData;
    var volRow = d.volumeDiscount > 0 ? '<div class="fb2bc-sum dto"><span>Descuento por volumen</span><b>−' + money(d.volumeDiscount) + '</b></div>' : '';
    var ivaRow = (d.iva > 0) ? '<div class="fb2bc-sum"><span>IVA ' + d.ivaPct + '%</span><b>' + money(d.iva) + '</b></div>' : '<div class="fb2bc-sum"><span>IVA</span><b>0,00 € · intracom.</b></div>';
    var reRow = d.re > 0 ? FT('<div class="fb2bc-sum re"><span>Recargo de equivalencia ') + d.rePct + '%</span><b>' + money(d.re) + '</b></div>' : '';
    // LA BASE IMPONIBLE, SOLO CUANDO DICE ALGO. Es el subtotal menos el descuento
  // por volumen, así que sin descuento sale el MISMO número dos filas seguidas:
  // en el móvil eso es una línea robada al botón de pagar, y encima confunde
  // —quien lo lee busca en qué se diferencian—. Con descuento sí se enseña,
  // porque entonces es el número sobre el que se calcula el IVA.
  var baseRow = (d.volumeDiscount > 0) ? '<div class="fb2bc-sum"><span>Base imponible</span><b>' + money(d.baseImponible) + '</b></div>' : '';
  var breakdown = compact ? '' : ('<div class="fb2bc-sum"><span>Subtotal profesional (sin IVA)</span><b>' + money(d.subtotalNet) + '</b></div>' + volRow + baseRow + ivaRow + reRow);
    var panel = document.createElement('div');
    panel.className = 'fb2bc' + (compact ? ' fb2bc--compact' : '');
    panel.innerHTML = FT('<div class="fb2bc-h">🛒 Tu pedido profesional <span class="fb2bc-tag">PRECIOS B2B</span></div>')
      + '<div class="fb2bc-sums">' + breakdown
      + '<div class="fb2bc-sum total"><span>Total a pagar</span><b>' + money(d.total) + '</b></div></div>'
      + FT('<button type="button" class="fb2bc-btn fb2bc-go">Finalizar pedido profesional →</button>')
      + '<div class="fb2bc-note">Precios netos. IVA' + (d.re > 0 ? ' y recargo' : '') + ' incluidos en el total.</div>';
    panel.querySelector('.fb2bc-go').addEventListener('click', doCheckout);
    return panel;
  }

  // Los botones de compra normales solo se ocultan MIENTRAS haya panel B2B a la vista.
  function syncOn(hayPanel) {
    document.documentElement.classList.toggle('fb2b-cart-on', !!hayPanel);
  }

  function paintPanel() {
    var vacio = !cartData || !cartItems || !cartItems.length;
    // Firma del contenido: si no cambia, el panel se deja tal cual (sin parpadeo).
    var sig = vacio ? '' : (lastSig + '|' + cartData.total);
    var hosts = [
      [document.querySelector('.cart__footer-wrapper') || (onCartPage ? document.querySelector('.cart__footer') : null), false],
      [document.querySelector('.cart-drawer__footer') || document.querySelector('.drawer__footer'), true],
    ];
    var hay = false;
    hosts.forEach(function (h) {
      var host = h[0], compact = h[1];
      if (!host) return;
      var ex = host.querySelector('.fb2bc');
      if (vacio) { if (ex) ex.remove(); return; }
      if (ex && ex.getAttribute('data-sig') === sig) { hay = true; return; }
      var nuevo = buildPanel(compact);
      nuevo.setAttribute('data-sig', sig);
      // Se REEMPLAZA en su sitio: en ningún momento hay carrito sin botón.
      if (ex) host.replaceChild(nuevo, ex); else host.insertBefore(nuevo, host.firstChild);
      hay = true;
    });
    syncOn(hay);
  }

  function tick() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items) return;
      var sig = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      if (sig !== lastSig) {
        lastSig = sig;
        document.querySelectorAll('.price[data-b2b]').forEach(function (p) { p.removeAttribute('data-b2b'); });
        // El panel viejo se queda visible (marcado como que se está actualizando) hasta
        // que llega el nuevo importe: antes se borraba y quedaba un hueco sin botón.
        document.querySelectorAll('.fb2bc').forEach(function (p) { p.classList.add('fb2bc--upd'); });
        refresh(cart, function () { paintLines(); paintPanel(); });
      } else { paintLines(); paintPanel(); }
    }).catch(function () { });
  }
  if (document.readyState !== 'loading') tick(); else document.addEventListener('DOMContentLoaded', tick);
  // Antes esto se paraba a los 30 ciclos (36 s). Pasado ese rato, cualquier re-render del
  // tema (cambiar cantidad, abrir el cajón) se llevaba el panel por delante y ya no se
  // reponía: carrito sin botón de comprar. Ahora hay dos mecanismos permanentes.
  setInterval(function () { ticks++; tick(); }, 4000);            // latido lento de respaldo
  // Vigilante del DOM: en cuanto el tema vuelve a pintar el carrito, se repone el panel.
  var repintando = false;
  try {
    new MutationObserver(function () {
      if (repintando) return;
      var falta = !!(document.querySelector('.cart__footer-wrapper, .cart__footer, .cart-drawer__footer, .drawer__footer')
        && cartData && cartItems && cartItems.length && !document.querySelector('.fb2bc'));
      if (!falta) return;
      repintando = true;
      setTimeout(function () { repintando = false; paintLines(); paintPanel(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* navegador sin MutationObserver: queda el latido */ }
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { lastSig = ''; tick(); }, 120); });
})();

